import React, { Component } from 'react';

class Training extends Component {
  
  render() {
    const training = (
    <section id="certificates" className="resume-section">
	<article className="container">
	  <div className="row">
		<div className="category-title col-md-12">
		  <div className="row">
			<div className="col-md-4">
			  <h2>Microsoft Training</h2>
			</div>
		  </div>
		</div>
		<div className="card-container">
		  <span className="col-md-3 col-md-offset-1 side-note">Nov 2016</span>
		  <div className="col-md-6 resume-card">
			<h3 className="title">Querying Microsoft SQL Server 2014<small>Course 20461 Objectives</small></h3>
			<p>Understand the similarities and differences between Transact-SQL and other computer languages<br/>
	SELECT queries, Query multiple tables, Sort and filter data<br/>Describe the use of data types in SQL Server<br/>
	Modify data using Transact-SQL, Use built-in functions<br/>Group and aggregate data, Use subqueries <br/>
	Use table expressions,Use set operators<br/>Use window ranking, offset and aggregate functions<br/>
	Implement pivoting and grouping sets, Execute stored procedures<br/>Program with T-SQL, Implement error handling,Implement transactions</p>	
		  </div>
		</div>
		<div className="card-container">
		  <span className="col-md-3 col-md-offset-1 side-note">Nov 2015</span>
		  <div className="col-md-6 resume-card">
			<h3 className="title">ASP.NET MVC 4 Web Applications<small>Course 20486B</small></h3>
			<p> Designing the application architecture <br/>Designing the user interface<br/>Developing the user interface<br/>
	Troubleshooting and debugging web applications<br/>Designing and implementing security</p>
		  </div>
		</div>
	  </div>
	</article>
</section>
      
    );
    return (
         training
    );
  }
  
}

export default Training;



// WEBPACK FOOTER //
// ./src/components/resume-components/training.js